/**
 * @license
 * Copyright The Closure Library Authors.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Event types for goog.history.
 */


goog.provide('goog.history.EventType');


/**
 * Event types for goog.history.
 * @enum {string}
 */
goog.history.EventType = {
  NAVIGATE: 'navigate'
};
